import { TournamentDetailsData } from 'config/types/tournament'
import React from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import Heading from 'UIKit/Heading'
import Modal, { ModalBody, ModalHeader, ModalProps } from 'UIKit/Modal'
import LeaderBoardFullTable from './LeaderBoardTable/FullTable'

const LeaderBoardModal: React.FC<ModalProps<{ tournamentDetails: TournamentDetailsData }>> = ({
  onDismiss,
  data: { tournamentDetails },
}) => {
  return (
    <StyledModal
      minWidth={['100%', '', '368px !important', '608px !important']}
      maxWidth={['100%', '', '368px !important', '608px !important']}
      minHeight="578px !important"
      onDismiss={onDismiss}
      p="12px"
    >
      <ModalHeader pl={['12px', '', '12px']}>
        <StyledHeading scale="xs" mr="12px" color="textTertiary">
          <Trans>Leaderboard</Trans>
        </StyledHeading>
      </ModalHeader>

      <ModalBody
        borderRadius={`${0} !important`}
        pb={['12px', '', '24px']}
        width="100%"
        minHeight="463px"
        marginTop="-6px"
      >
        <LeaderBoardFullTable tournamentDetails={tournamentDetails} />
      </ModalBody>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  .wrap-header-container {
    background: none;
  }
`

const StyledHeading = styled(Heading)`
  font-weight: 700;
`

export default LeaderBoardModal
